import React from 'react'
import { Box, Chip, LinearProgress, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

import { DashboardTablePaper } from 'components'

import constants from 'constants/index'

import useStyles from './styles'

const QuestionnaireLinearProgressTable = ({
  title,
  questionnaires,
  percentage = false,
  ...rest
}) => {
  const classes = useStyles()

  const isNotApplicable = (questionnaire) =>
    questionnaire?.status === constants.questionnaire.NOT_APPLICABLE_STATUS

  return (
    <DashboardTablePaper
      title={title}
      tableType="questionnaire"
      className={classes.root}
      {...rest}
    >
      {questionnaires?.map((questionnaire) => (
        <Box px={2} key={questionnaire?.name}>
          <Box className={classes.lineTitle}>
            <Typography className={classes.rowName}>
              {questionnaire?.name}
            </Typography>
            {isNotApplicable(questionnaire) ? (
              <Chip label="Não se Aplica" size="small" color="secondary" />
            ) : (
              <Typography className={classes.rowValue}>
                {questionnaire?.value}
                {percentage && '%'}
              </Typography>
            )}
          </Box>
          <Box>
            <LinearProgress
              className={
                isNotApplicable(questionnaire)
                  ? classes.notApplicableLineBar
                  : classes.lineBar
              }
              variant="determinate"
              value={Number(questionnaire?.percentage)}
            />
          </Box>
        </Box>
      ))}
    </DashboardTablePaper>
  )
}

QuestionnaireLinearProgressTable.propTypes = {
  rows: PropTypes.array,
  percentage: PropTypes.bool,
}

export default QuestionnaireLinearProgressTable
